/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Polish language
 *
 * @file pl.js
 * @author Manimaran.S
 */

const pl = {
  'popularChannelSlider.allChannels': 'Wszystkie kanały',
  'popularChannelSlider.recommended': 'Zalecane',
  'hero.myetextbook.link': 'biblioteka',
  'hero.myetextbook.text': 'Niewłaściwy tytuł? Uzyskaj dostęp do eTextbook',
  'hero.etextfeaturestitle': 'Znajdź materiały do nauki w eTextbook',
  'hero.etextfeaturesdescription': 'Twój eTextbook zawiera materiały do nauki, które pomogą Ci odnieść sukces. Ucz się za pomocą fiszek i innych materiałów dostępnych bezpośrednio w Twoim eTextbook.',
  'aichat.title1': 'Uzyskaj pomoc opartą na sztucznej inteligencji we wszystkich kwestiach związanych z eTextbook.',
  'aichat.chatDesc1': 'Wpisz pytanie, aby rozpocząć',
  'subscriptiontext.isSubscribed': 'Część Twojej subskrypcji',
  'subscriptiontext.nonSubscriber': 'Zaktualizuj, aby uzyskać pełny dostęp',
  'topicConatiner.otherHeader': '-',
  'topicConatiner.exactLiteHeader': '-',
  'moremenu.downloadApp': '-',
  'moremenu.downloadAppAlreadyDownload': '%Click here%, aby pobrać aplikację na inne urządzenie i zalogować się automatycznie lub użyć unikalnego kodu QR do bezpiecznego zalogowania się w aplikacji, którą już zainstalowałeś.',
  'moremenu.downloadAppNotDownload': '%Click here%, aby pobrać aplikację i bezpiecznie zalogować się za pomocą unikalnego kodu QR.',
  'channel.noBundletitle': 'Skorzystaj z Przygotowania do nauki dla powiązanych i innych kursów',
  'onboard.studyPlan': 'Utworzono indywidualny plan nauki!',
  'onboard.addCourseAnother': 'Czy chcesz dodać kolejny kurs?',
  'onboard.purchase': 'Muszę kupić e-Textbook Pearson',
  'onboard.addCourseWithoutEtext': 'Dodaj kurs za pomocą Przygotowania do nauki',
  'onboard.mayBeLater': 'Może później',
  'onboard.aboutCourse': 'Opowiedz nam o swoim kursie',
  'onboard.close': 'Zamknij',
  'course.addTitle': 'Dodaj kurs',
  'common.PURCHASE': 'Zakup',
  'common.CLOSE': 'Zamknij',
  'open': 'otwórz',
  'continue': 'Kontynuuj',
  'yes': 'Tak',
  'no': 'Nie',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': 'Sukces!',
  'courses.toc.PUBLISH_MESSAGE': 'Studenci zobaczą Twoje zmiany, gdy następnym razem otworzą treść.',
  'errors.GENERIC_TITLE': '-',
  'errors.GENERIC_DESC': '-',
  'errors.GENERIC_LINK': '-',
  'errors.GENERIC_CODE': '-',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Nie znaleziono subskrypcji',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Twoje konto nie obejmuje dostępu do tego tytułu. Jeśli uważasz, \n    że otrzymałeś ten komunikat przez pomyłkę, skontaktuj się z pomocą techniczną Pearson',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Nie znaleziono subskrypcji',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Twoja subskrypcja nie obejmuje dostępu do aplikacji eText, \n    jednak możesz ją teraz zasubskrybować za pomocą karty kredytowej.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Moje konto',
  'menu.helpCenter': 'Centrum pomocy',
  'menu.preferencesCenter': 'Centrum preferencji',
  'menu.CONTACT_SUPPORT': 'Kontakt z pomocą techniczną',
  'menu.HELP_SUPPORT': 'Pomoc i wsparcie',
  'menu.FAQS': 'Często zadawane pytania',
  'menu.CHAT_WITH_SUPPORT': 'Czat z pomocą techniczną',
  'menu.OTP_CODES': 'Kody OTP',
  'menu.LAUNCH_CODE': 'Uruchom dziennik kodów',
  'menu.SEND_CODE': 'Wyślij nowy kod użytkownika przez e-mail',
  'menu.SEND_CODE_PHONE': 'Wyślij nowy kod użytkownika przez wiadomość SMS',
  'menu.LEGAL': 'Prawne',
  'menu.PRIVACY_NOTICE': 'Informacja o prywatności',
  'menu.TITLE_INFO': 'Informacja tytułowa',
  'menu.PEARSON_ACCESSIBILITY': 'Dostępność Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Zarejestruj {deviceLimit} urządzenia. Wymieniaj 1 raz w miesiącu.',
  'menu.ACCESSIBILITY': 'Dostępność',
  'menu.ACCESSIBILITY_SUPPORT': 'Wsparcie dostępności',
  'menu.DEVICES': 'Ostatnie urządzenia',
  'menu.THIS_DEVICE': 'To urządzenie',
  'menu.GET_THE_APP_DOWNLOAD': 'Pobierz aplikację mobilną',
  'menu.MOJO_APP_INFO': 'Aby korzystać z Pearson+ w trybie offline, przejdź do sklepu z aplikacjami na swoim telefonie lub tablecie.',
  'menu.DEVICE_LABEL': 'Urządzenie',
  'menu.DEVICE_DISCONNECT': 'Rozłącz',
  'menu.FOXIT': 'Obsługiwane przez Foxit',
  'menu.TERMS_OF_USE': 'Warunki korzystania',
  'menu.SIGN_OUT': 'Wyloguj',
  'menu.PRINT_PAGE': 'Drukuj stronę',
  'menu.COPY_RIGHT': 'Prawo autorskie © {year} Pearson Education Inc. Wszystkie prawa zastrzeżone.',
  'print.FOOTER_MESSAGE': 'Wydrukowano {fullName}({email}) w dniu {currentDate}.',
  'print.WATERMARK': '-',
  'device.SWAPPED_ALREADY': 'W tym miesiącu już dokonałeś zamiany',
  'device.SWITCH_DEVICE': 'Przełączyć się na bieżące urządzenie?',
  'device.SWITCH_ONCE': 'Ponieważ możesz się przełączyć tylko raz w miesiącu, nie będziesz mógł się cofnąć.',
  'device.SEAT_TAKEN': 'To miejsce jest zajęte',
  'device.DISCONNECT_DEVICE': 'Możesz zalogować się tylko na 3 urządzeniach. Aby kontynuować, odłącz kolejne urządzenie.',
  'device.ALERT_TEXT': 'Pamiętaj, że możesz zmieniać urządzenia tylko raz w miesiącu.',
  'device.DISCONNECT': 'Rozłącz',
  'device.CONTINUE': 'Kontynuuj',
  'device.HEADER': 'Czy zakończyć sesję w innej przeglądarce?',
  'device.CLOSE': 'Powrót do strony głównej',
  'device.CODE': '-',
  'device.TIMER': 'Masz {time}, aby wprowadzić swój kod tutaj',
  'device.RESEND': '-',
  'device.FAQ': '-',
  'device.RESEND_NAME': 'Wyślij ponownie',
  'device.NOTE': '-',
  'device.NOTE_HEADER': '-',
  'device.CONTACT_SUPPORT': 'pomoc techniczna',
  'device.CONTACT_EMAIL': 'zaktualizuj adres e-mail',
  'device.INCORRECT': 'Nieprawidłowy - sprawdź ponownie swój kod lub wyślij go ponownie.',
  'device.MANY_ATTEMPTS': 'Zbyt wiele prób, spróbuj wysłać kod ponownie',
  'device.EXPIRED': 'Czas minął, spróbuj wysłać kod ponownie',
  'device.ACCESS_HEADER': 'Jesteś zalogowany!',
  'device.ACCESS_DESC': 'Twoja sesja została uwierzytelniona. Chcesz w tym czasie zaktualizować swoje hasło?',
  'device.ACCESS_CHANGE_PASSWORD': 'Zmień hasło',
  'device.ACCESS_RESET_PASSWORD': 'Zresetuj hasło',
  'device.THREATONE_TITLE': 'Wszystko OK?',
  'device.THREATONE_DESC': 'Zauważyliśmy podejrzaną aktywność na Twoim koncie.',
  'device.THREATONE_DESC_TWO': 'To dobry moment na zmianę hasła.',
  'device.MAY_BE_LATER': 'Może później',
  'device.OKAY': 'OK',
  'device.ACCOUNT_LOCK_DESC': 'Aby zapewnić bezpieczeństwo, wylogowaliśmy Cię. Wysłaliśmy link resetujący hasło na adres e-mail przypisany do Twojego konta.',
  'device.ACCOUNT_LOCK_TITLE': 'Zauważyliśmy podejrzaną aktywność na Twoim koncie',
  'device.ACCOUNT_LOCK_TIMER': 'Zostaniesz wylogowany za {time}',
  'navigation.PAGE': 'Strona',
  'launchcode.CREATEBY': 'Utworzony przez:',
  'launchcode.sentvia': 'Wysłany za pomocą:',
  'launchcode.CODEINLAST': 'Kody z ostatnich 7 dni:',
  'launchcode.TIMESENT': 'Godzina wysyłki:',
  'launchcode.ACCOUNTEMAIL': 'Adres e-mail klienta:',
  'launchcode.LAUNCHDIALOGTITLE': 'Dziennik kodów OTP',
  'textmessage.TITLE': 'Wprowadź numer telefonu',
  'textmessage.PHONE_NUMBER': 'Numer telefonu',
  'textmessage.SEND_CODE': 'Wyślij kod',
  'textmessage.INVALID_NUMBER': 'Nieprawidłowy numer telefonu komórkowego.',
  'textmessage.SUCCESS_MESSAGE': 'Kod został wysłany',
  'remove.title': 'Usunąć tytuł?',
  'remove.subTitle': 'Zawsze możesz odzyskać go później - wystarczy użyć wyszukiwania, aby ponownie go dodać.',
  'remove.buttonText': 'Usuń',
  'search.searchPlaceHolderPPlus': 'Wyszukaj według ISBN, tytułu lub autora',
  'search.searchPlaceHolderEText': 'Przeszukaj swoją bibliotekę',
  'footer.downloadMobileApp': 'Pobierz aplikację mobilną',
  'footer.termsOfUse': 'Warunki korzystania',
  'footer.privacy': 'Prywatność',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': 'Nie sprzedawaj moich danych osobowych',
  'footer.accessibility': 'Dostępność',
  'footer.patentNotice': 'Informacja o patencie',
  'footer.copyrights': 'Pearson Wszystkie prawa zastrzeżone.',
  'hero.toc.defaultPlacehoder': '-',
  'hero.openEtextBookV1': 'Otwórz podręcznik eText',
  'hero.heroHeading': 'Poniewać uczysz się <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Przygotowanie do nauki',
  'hero.study.help': 'Uzyskaj pomoc w nauce',
  'hero.study.jumpBackIn': 'Wróć do gry',
  'hero.study.numOfUsers': 'Obecnie z kanałów korzysta <b>{num_of_users}</b> studentów.',
  'hero.heroChannel.cardsHeading': 'Kontynuuj tam, gdzie przerwałeś',
  'hero.marketingcard1.copy.title': 'Ucz się z pomocą filmów',
  'hero.marketingcard1.copy.description': 'Obejrzyj objaśnienia wideo, które wyjaśniają trudne tematy.',
  'hero.marketingcard2.copy.title': 'Problemy w praktyce',
  'hero.marketingcard2.copy.description': 'Przygotuj się do egzaminu z tysiącami pytań egzaminacyjnych i rozwiązań wideo',
  'hero.marketingcard3.copy.title': 'Uzyskaj doświadczoną pomoc',
  'hero.marketingcard3.copy.description': 'Zadawaj pytania i otrzymuj odpowiedzi od ekspertów w danej dziedzinie.',
  'hero.popularTopics.heading': 'Inne popularne tematy na tym kanale',
  'hero.popularChannels.headingv1': 'Bierzesz udział w kolejnym kursie?',
  'hero.popularChannels.descriptionv2': 'Przeglądaj popularne tematy pomocy w nauce.',
  'hero.practice': 'Przećwicz',
  'hero.herobook.mappedChannelHeading': 'Polecana pomoc w nauce na tym kanale',
  'libraryL2.myBooks': '-',
  'libraryL2.archived': 'Dodany do archiwum',
  'libraryL2.back': 'Wróć',
  'hero.practiceProblem': '-',
  'nativeAppBanner.drawer.title': '-',
  'nativeAppBanner.drawer.pearsonApp': '-',
  'nativeAppBanner.banner.title': '-',
  'nativeAppBanner.banner.description': '-',
  'hero.promotionalcard.list1': 'Krótkie filmy, które wyjaśniają trudne tematy',
  'hero.promotionalcard.list2': 'Tysiące pytań egzaminacyjnych',
  'hero.promotionalcard.list3': 'Otrzymuj odpowiedzi od ekspertów w danej dziedzinie',
  'hero.studyandexamprep': 'Przygotowanie do nauki',
  'hero.heroBook.sectionSubHeadingV1': 'Zgłębiaj trudne tematy dzięki objaśnieniom w formie filmików wideo i pytaniom praktycznym dostosowanym do Twojego kursu.',
  'hero.heroBook.sectionSubHeadingV2': 'Zgłębiaj trudne tematy dzięki objaśnieniom pojęć i pytaniom praktycznym dostosowanym do Twojego kursu.',
  'hero.SeeAllStudyOptions': '-',
  'hero.herobook.mappedChannelHeadingV1': '-',
  'hero.popularTopics.headingV1': 'Inne popularne tematy',
  'hero.heroHeadingV1': '-',
  'hero.learnmore': 'Dowiedz się więcej',
  'hero.eTextbook': 'Podręcznik eText',
  'hero.goToPage.label': 'Przejdź do strony',
  'subscription.studyTitle': 'Przygotowanie do nauki',
  'print.printAvailTitle': 'Chcesz wydrukować tę stronę? Oto jak',
  'print.printAvailDesc': 'W eTexbook wybierz ikonę konta w prawym górnym rogu. W opcjach wybierz „Drukuj stronę”, a następnie wybierz ustawienia drukowania.',
  'print.printNotAvailTitle': '-',
  'print.printNotAvailDesc': '-',
  'hero.header.cta': '-',
  'hero.header.ctav2': 'Otwórz Przygotowanie do nauki',
  'hero.marketing.title': 'Znajdź swój podręcznik eText',
  'hero.marketing.subTitle': 'Wybieraj spośród ponad 2000 podręczników e-Text z dźwiękiem, fiszkami, notatkami i nie tylko. Tylko 10,99 USD miesięcznie za 4-miesięczny okres.',
  'hero.popularchannels.desc': 'Uzyskaj pomoc w nauce tych najważniejszych przedmiotów',
  'hero.removecourse.title': 'Usunąć kurs z pulpitu nawigacyjnego?',
  'hero.removecourse.description': 'Zawsze możesz dodać ten kurs z powrotem do pulpitu nawigacyjnego, klikając „Dodaj kurs”',
  'hero.removecourse.primaryCtaText': 'Usuń',
  'hero.removecourse.secondaryCtaText': 'Anuluj',
  'hero.tableOfContents': 'Spis treści',
  'hero.search': 'Wyszukaj',
  'hero.emptystate.cta': 'Wyszukaj elementy eTextbook',
  'hero.watch_it_again': 'Obejrzyj ponownie',
  'hero.mondly.learnLang.title': 'Naucz się nowego języka za darmo',
  'hero.mondly.subTitle': 'Użytkownicy eTextbook Pearson otrzymują trzy bezpłatne miesiące Mondly by Pearson.',
  'hero.mondly.description': 'Większość aplikacji do nauki języków obcych pozwala uczyć się tylko z poziomu języka angielskiego. Najlepiej jest jednak uczyć się w swoim ojczystym języku, więc Mondly umożliwia naukę w dowolnym z 41 języków.',
  'hero.mondly.startLearningCTA': 'Rozpocznij naukę',
  'hero.mondly.marketing.bestApp': '-',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': '-',
  'hero.mondly.marketing.fbStart': '-',
  'hero.mondly.marketing.editorChoice': '-',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Naucz się języka',
  'header.menu.moreAtPearson': 'Więcej na stronie Pearson',
  'hero.subscriptionStatusTitle2': 'Twoje zasoby Pearson+',
  'hero.startStudying': 'Rozpocznij naukę',
  'onboard.studyMaterials': 'Wybierz swój przedmiot, a my stworzymy pulpit nawigacyjny ze spersonalizowanymi materiałami do nauki.',
  'hero.myETextbooks': 'Moje podręczniki eText',
  'header.continueInTheApp': 'Kontynuuj w aplikacji',
  'hero.learnTxt': 'Ucz się',
  'hero.examPrepTxt': 'Przygotowanie do egzaminu',
  'hero.aITutorTxt': 'Nauczyciel AI',
  'AI.toolTip': 'Zapytaj mnie o swój eTextbook',
  'hero.studyExamPrepAllYourCourses': 'Przygotowanie do nauki dla wszystkich Twoich kursów',
  'header.qrCode.subHeaderTxt': 'Użyj tego kodu QR, aby szybko i bezpiecznie zalogować się do aplikacji Pearson+ na urządzeniu mobilnym.',
  'header.qrCode.dontHaveApp': 'Nie masz aplikacji?',
  'header.qrCode.footerTxt': 'Zeskanowanie tego kodu spowoduje przekierowanie do sklepu App Store lub Google Play. Po pobraniu aplikacji zaloguj się, skanując ponownie kod.',
  'header.qrCode.errorMsg': 'Kod QR nie został załadowany. Zamknij i spróbuj ponownie',
  'hero.yourETextbook': 'Twój podręcznik eText',
  'onboard.addCourseWithEtextBundle': 'Dodaj kurs za pomocą Przygotowania do nauki',
  'onboard.disableTooltipText': 'Dodano wszystkie kursy związane z Przygotowaniem do nauki!',
  'subscriptionstatus.bundlecta': 'Uzyskaj dostęp do Przygotowania do nauki',
  'subscriptionstatus.nonbundlecta': 'Uzyskaj dostęp do Przygotowania do nauki',
  'channel.genericBundle': 'Wykorzystaj Przygotowanie do nauki dla potrzeb innych kursów',
  'channel.relatedBundle': 'Wykorzystaj też Przygotowanie do nauki dla potrzeb innych kursów',
  'onboard.courseAdded': 'Kurs dodany!',
  'hero.flashcards': 'Fiszki',
  'relatedChannelCard.title': 'Wzbogać swoją wiedzę dzięki tym powiązanym zasobom',
  'relatedChannelCard.badgeText': 'Powiązane zasoby Przygotowania do nauki',
  'sessionInactivity.title': 'Wciąż tam jesteś?',
  'sessionInactivity.description': '-',
  'sessionInactivity.keepMeSignIn': 'Nie pozwól mi się wylogować',
  'sessionInactivity.signOut': 'Wyloguj',
  'sessionTimeout.title': 'Sesja wygasła',
  'sessionTimeout.description': 'Twoja sesja wygasła z powodu braku aktywności.',
  'print.qrCode.header': 'Użyj tego kodu QR, aby szybko i bezpiecznie otworzyć aplikację Pearson+ na urządzeniu mobilnym.',
  'print.qrCode.footer': 'Zeskanowanie tego kodu spowoduje przekierowanie do sklepu App Store lub Google Play. Po zainstalowaniu aplikacji zaloguj się, aby pobrać i uzyskać dostęp do swojego tytułu.',
  'hero.nestest.title': '-',
  'hero.nestest.subTitle': '-',
  'hero.channelAI.title': 'Potrzebujesz pomocy? Nauczyciel AI ma wszystko pod kontrolą.',
  'hero.channelAI.desc': 'Zadaj pytanie i otrzymaj szczegółową pomoc w odrabianiu zadań domowych, zalecenia dotyczące nauki i wiele więcej — spersonalizowaną pomoc uzyskasz zawsze, gdy jej potrzebujesz.',
  'hero.channelAI.action': 'Już teraz zadaj pytanie nauczycielowi AI',
  'new': 'Nowość!',
  'hero.practice.numOfUsers': '-',
  'hero.practice.cta': '-',
  'hero.practice.title': '-',
  'diagnostics.errorMsg': 'Diagnostyka nie została załadowana. Zamknij i spróbuj ponownie',
  'qrcode.title': '-',
  'qrcode.subtitle': '-',
  'qrcode.detailsv1': '-',
  'qrcode.detailsv2': '-',
  'qrcode.details': '-',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': '-',
  'install': 'Install',
  'header.menu.createCourse': 'Nowy kurs',
  'header.dropdown.courses': 'Kursy',
  'header.dropdown.recentlyViewed': 'Ostatnio przeglądane',
  'header.dropdown.viewAll': 'Zobacz wszystkie kursy',
  'aet.courseHeader.inviteStudents': 'Zaproś studentów',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Zachęć studentów do skorzystania z tego e-Textbooka, kopiując poniższy adres linku lub instrukcje do wiadomości e-mail lub do programu zajęć.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Adres łącza',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Kopiuj link',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instrukcje z adresem łącza',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Kopiuj instrukcje',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'Czas zapoznać się z {bookTitle} eTextbook do {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'Kiedy będziesz gotowy, uzyskaj dostęp do eTextbook pod adresem: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Zostaniesz poproszony o zalogowanie się przy użyciu swojego istniejącego konta Pearson. Jeśli nie masz konta Pearson, będziesz mógł je założyć.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Potrzebujesz pomocy?',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Data rozpoczęcia:',
  'aet.courseHeader.endDate': 'Data zakończenia:',
  'aet.courseHeader.start': 'Start:',
  'aet.courseHeader.end': 'End:',
  'aet.courseHeader.moreOptions': 'More options',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Format:',
  'aet.home.manageroster': 'Zarządzaj listą',
  'aet.home.managegradesync': 'Zarządzaj synchronizacją ocen',
  'aet.home.copycourse': 'Kopiuj kurs',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',

  'aet.instructorCourse.tabs.current': 'Bieżący',
  'aet.instructorCourse.tabs.past': 'Przeszłe',
  'aet.instructorCourse.tabs.courseSettings': 'Ustawienia kursu',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': 'Zarządzaj listą',
  'aet.instructorCourse.currentCourses.title': 'Bieżące kursy',
  'aet.instructorCourse.pastCourses.title': 'Poprzednie kursy',
  'aet.instructorCourse.archivedCourses.title': 'Archived courses',
  'aet.instructorCourse.archivedCourses.description': 'Archived titles are hidden from Current and Past. Your access to each title doesn’t change — unarchive it any time to put it back on your bookshelf.',
  'aet.instructorCourse.archivedCourses.emptyStateTitle': 'No archived titles',
  'aet.instructorCourse.archivedCourses.emptyStateDescription': 'Archive a title from Current or Past using its ··· menu. It moves here without changing your access.',
  'aet.instructorCourse.archiveDialog.title': 'Archive title(s)',
  'aet.instructorCourse.archiveDialog.description': 'Archived titles will move to the Archived tab, and all courses that use that title will be archived. They can still be accessed from the archived section, directly from the MLM course, and from Console. You can unarchive it anytime from the Archived tab.',
  'aet.instructorCourse.archiveDialog.confirmCTA': 'Archive',
  'aet.instructorCourse.unarchiveDialog.title': 'Unarchive title(s)',
  'aet.instructorCourse.unarchiveDialog.description': 'Unarchived titles will be accessible from your home page.',
  'aet.instructorCourse.unarchiveDialog.confirmCTA': 'Unarchive',
  'aet.home.archiveCourse': 'Archive',
  'aet.home.unarchiveCourse': 'Unarchive',
  'aet.instructorCourse.createOrCopy.title': 'Utwórz lub skopiuj kurs z eTextbook Pearson',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Skopiuj kurs innego prowadzącego lub utwórz nowy',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Skopiuj kurs innego prowadzącego',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Wpisz ID kursu, aby znaleźć kurs, który chcesz skopiować.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'ID kursu',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Wpisz ID kursu',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Szukałeś',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Utwórz nowy kurs z katalogu',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Wyszukaj według tytułu, autora, numeru ISBN lub słów kluczowych związanych z tematyką.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Wyszukaj...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Pokaż więcej',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Pokaż mniej',
  'aet.instructorCourse.cancel': 'Anuluj',
  'aet.instructorCourse.loading': 'Ładowanie...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Synchronizacja ocen',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Zarządzaj synchronizacją ocen',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Nazwa kursu',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Bez tytułu',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Nazwa sekcji',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Bez tytułu',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Instytucja',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Instytucja jest wymagana',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Coś poszło nie tak. Spróbuj ponownie.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Brak wyników',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.startDateLabel': 'Data rozpoczęcia kursu',
  'aet.instructorCourse.courseForm.endDateLabel': 'Data zakończenia kursu',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/rr',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Zezwól innym na skopiowanie tego kursu',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Udostępnij ten kod instruktorom, którzy chcą skopiować ten kurs',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Kopiuj kod',
  'aet.instructorCourse.courseForm.optionalSuffix': '(opcjonalnie)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'W formularzu występują błędy walidacji',
  'aet.instructorCourse.courseForm.submitContinue': 'Kontynuuj',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Zapisywanie...',
  'aet.instructorCourse.courseForm.submitError': 'Nie udało nam się utworzyć twojego kursu. Spróbuj ponownie.',
  'aet.instructorCourse.courseForm.submitEditError': 'Nie udało nam się zapisać wprowadzonych zmian. Spróbuj ponownie.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Zapisz zmiany',
  'aet.instructorCourse.courseForm.materialsHeader': 'Materiały szkoleniowe',
  'aet.instructorCourse.courseForm.resolveError': 'Nie udało nam się załadować materiałów szkoleniowych. Spróbuj ponownie.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Ostatnio przeglądane',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Ostatnio dodane',
  'aet.instructorCourse.coursesSort.aToZ': 'A do Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z do A',
  'aet.instructorCourse.manageRoster.column.name': 'Nazwa',
  'aet.instructorCourse.manageRoster.column.role': 'Rola',
  'aet.instructorCourse.manageRoster.column.email': 'E-mail',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': 'Status',
  'aet.instructorCourse.manageRoster.column.statusInfoTooltip': 'Status information',
  'aet.instructorCourse.manageRoster.statusInfoModal.title': 'Status',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph1': 'This status reflects Pearson enrollment and may not match a student\'s enrollment status in your linked LMS course.',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph2': 'Students marked as Inactive will not have grades synced back to the LMS.',
  'aet.instructorCourse.manageRoster.access.tempAccessTitle': 'Temporary access',
  'aet.instructorCourse.manageRoster.access.active': 'Active eTextbook access',
  'aet.instructorCourse.manageRoster.access.endsOn': 'Ends: {date}',
  'aet.instructorCourse.manageRoster.access.ended': 'Ended:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.roster.role.student': 'Student',
  'aet.instructorCourse.roster.role.ta': 'Asystent Dydaktyczny',
  'aet.instructorCourse.roster.role.instructor': 'Instruktor',
  'aet.instructorCourse.roster.status.active': 'Aktywny',
  'aet.instructorCourse.roster.status.inactive': 'Nieaktywny',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Wszyscy członkowie',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Aktywni studenci',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Nieaktywni studenci',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Asystent dydaktyczny',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Instruktor',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Autor:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Data utworzenia kursu:',
  'aet.instructorCourse.noCoursesFound': 'Nie znaleziono kursów',
  'aet.instructorCourse.searchNoResultsTitle': 'No courses match “{searchTerm}”',
  'aet.instructorCourse.searchNoResultsDescription': 'Try a different course name.',
  'aet.instructorCourse.clearSearch': 'Clear search',
  'aet.instructorCourse.noCoursesEmptyStateTitle': 'Nothing here yet',
  'aet.instructorCourse.noCoursesEmptyStateDescription': 'Courses you create or are added to will appear here.',
  'aet.instructorCourse.backButton': 'Wróć',
  'aet.instructorCourse.selectCourse': 'Wybierz kurs',
  'aet.home.linkedToLms': 'Powiązano z LMS',
  'aet.instructorCourse.courseForm.title.create': 'Utwórz kurs',
  'aet.instructorCourse.courseForm.title.copy': 'Kopiuj kurs',
  'aet.instructorCourse.courseForm.title.edit': 'Informacje o kursie',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Ustawienia',
  'aet.studentRoster.manageStudentRosterButton': 'Zarządzaj listą studentów',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': 'Eksportuj postęp studentów',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Status:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Zarejestrowany:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Rola:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promować {studentName} ?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Jako asystent dydaktyczny osoba ta będzie mogła śledzić postępy i wyniki wszystkich studentów w tej grupie.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'Będzie również mogła zarządzać studentami i zadaniami, jednak nie będzie mogła usunąć zajęć.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Promuj na asystenta dydaktycznego',
  'aet.home.manageRoster.searchPlaceholder': 'Wyszukaj studenta',
  'aet.home.manageRoster.inactivateButtonLabel': 'Deaktywuj wybranych studentów',
  'aet.home.manageRoster.FilterLabel': 'Pokaż',
  'aet.home.manageRoster.updatingMessage': 'Aktualizowanie listy... Może potrwać kilka minut.',
  'aet.home.courses.search.searchPlaceHolder': 'Wyszukaj swoje kursy',
  'aet.courses.emptyStateDescription': 'Zacznij tworzyć swój kurs, wybierając jedną z poniższych opcji.',
  'nativePromoBanner.continueInBrowser': '-',
  'globalnav.tooltip.hideNavText': '-',
  'globalnav.tooltip.showNavText': '-',
  'aet.syllabus.progressTitle': 'Wyodrębnianie...',
  'aet.syllabus.progressDesc': 'Proszę czekać, aż przetworzymy Twój sylabus.',
  'aet.syllabus.uploadInputLabel': 'Przeciągnij i upuść pliki lub kliknij, aby je przesłać',
  'aet.syllabus.uploadSyllabusTabLabel': 'Prześlij sylabus',
  'aet.syllabus.dateAdjusterTabLabel': 'Regulator daty',
  'aet.syllabus.addManuallyTabLabel': 'Dodawaj zadania ręcznie',
  'aet.syllabus.addEditLaterText': 'Zadania można zawsze dodać i edytować później',
  'aet.syllabus.editAssignmentLabel': 'Edytuj zadanie',
  'aet.syllabus.addAssignmentLabel': 'Dodaj zadanie',
  'aet.syllabus.assignmentTitleLabel': 'Tytuł zadania',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': 'Termin',
  'aet.syllabus.editDueDateLabel': '-',
  'aet.syllabus.chaptersCoveredLabel': 'Wybierz rozdziały lub sekcje do nauki.',
  'aet.syllabus.updateCtaLabel': 'Aktualizuj zadanie',
  'aet.syllabus.addCtaLabel': 'Dodaj zadanie',
  'aet.syllabus.uploadLabel': 'Prześlij',
  'aet.syllabus.confirmLabel': 'Potwierdź',
  'aet.syllabus.addContentLabel': 'Dodawaj treści',
  'aet.syllabus.addEditContentLabel': 'Dodaj/Edytuj treść',
  'aet.syllabus.notPublishedLabel': 'Nieopublikowano',
  'aet.syllabus.updateDatesLabel': 'Data aktualizacji',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Zaktualizowano termin. Powtórz je, a następnie opublikuj.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Informacje dotyczące twojego rozdziału/sekcji zostały zaktualizowane. Powtórz je, a następnie opublikuj.',
  'aet.syllabus.unassignedCoverageStatus': 'Niektóre rozdziały nie zostały jeszcze przydzielone. Przypisz je przed opublikowaniem.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': 'Usunąć zadanie?',
  'aet.deleteAssignmentTitleMultiple': 'Usunąć zadania?',
  'aet.deleteAssignmentWarning': 'Czynności tej nie można cofnąć, a wszystkie powiązane materiały i dane studentów nie będą już widoczne.',
  'aet.deleteAssignmentKeepCTA': 'Zachowaj zadanie',
  'aet.deleteAssignmentDeleteCTA': 'Usuń',
  'aet.assignments.loadingAsset': 'Ładowanie zasobu...',
  'aet.assignments.addToDate': 'Dodaj do daty',
  'aet.assignments.previewAsStudent': 'Podgląd z perspektywy studenta',
  'aet.assignments.questionsAndTopics': 'Pytania i tematy',
  'aet.assignments.questionsAndTopicsModal.doneLabel': 'Gotowe',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': 'Termin',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': 'Łączna liczba pytań',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': 'Pytanie {count} z {total}',
  'aet.assignments.questionsAndTopicsModal.sectionSelectLabel': 'Select a section',
  'aet.assignments.publishToStudents': 'Opublikuj dla studentów',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': 'Dodaj datę',
  'aet.assistedSchedule.addToAssignmentModalTitle': 'Add to assignment',
  'aet.assistedSchedule.addToAssignmentModalEmptyLabel': 'No content yet',
  'aet.doneLabel': 'Gotowe',
  'aet.assignments.dueDateLabel': 'Termin oddania zadania',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now:',
  'aet.onboarding.getStarted.manualSetup.title': 'Konfiguracja ręczna',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.manualSetup.ctaLabel': 'Create manually',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Weekly schedule',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Pick a due day that repeats all term, then drag chapters into each week',
  'aet.onboarding.getStarted.assistedScheduling.ctaLabel': 'Build schedule',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Turn assigned reading into active learning',
  'aet.onboarding.promotion.feature.1': 'Quickly create assignments with embedded questions, plus optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': 'Wykorzystaj analizy w czasie rzeczywistym, aby zidentyfikować luki w wiedzy, co pozwoli Ci podjąć działania na wczesnym etapie z pełnym przekonaniem',
  'aet.onboarding.promotion.feature.3': 'Studenci otrzymują większe wsparcie dzięki ukierunkowanym informacjom zwrotnym oraz wbudowanej technologii sztucznej inteligencji Pearson AI',
  'aet.onboarding.getStarted.previewQuestions.prompt': 'Want to see what’s available?',
  'aet.onboarding.getStarted.previewQuestions.link': 'Preview all questions',
  'aet.questionPreview.title': 'Preview questions',
  'aet.questionPreview.chapterSelectLabel': 'Select chapter',
  'aet.questionPreview.questionLabel': 'question',
  'aet.questionPreview.questionsLabel': 'questions',
  'aet.questionPreview.correctAnswer': 'Correct answer',
  'aet.questionPreview.noQuestions': 'No questions are available for this chapter.',
  'aet.assistedSchedule.pageTitle': 'Weekly schedule',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set up a weekly schedule',
  'aet.assistedSchedule.sectionDescription': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysLabel': 'Have assignments due every',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose one or more days of the week',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.viewQuestions': 'View questions',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Start assignments by',
  'aet.assistedSchedule.endDateLabel': 'End assignments by',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.autoNameAssignmentsLabel': 'Automatically name assignments based on content',
  'aet.assistedSchedule.autoNameAssignmentsInstruction': 'Assignment names will be generated from the content.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assistedSchedule.addNewLabel': 'Add new',
  'aet.assistedSchedule.addToNewAssignmentLabel': 'Add to new assignment',
  'aet.assistedSchedule.saveAsDraftLabel': 'Save as draft',
  'aet.assistedSchedule.saveAndPublishLabel': 'Save and publish',
  'aet.assignments.allCaughtUpDescription': 'W tym tygodniu nie masz żadnych zadań do wykonania.',
  'aet.assignments.progressTitle': 'Postęp',
  'aet.assignments.performanceTitle': 'Pewność',
  'aet.assignments.completionTitle': 'Realizacja',
  'aet.assignments.statusTitle': 'Status',
  'aet.assignments.addTooltip': 'Dodaj zadanie',
  'aet.assignments.deleteTooltip': 'Usuń wybrane zadania',
  'aet.assignments.selectToDeleteLabel': 'Tryb zaznaczania i usuwania',
  'aet.assignments.bulkEditTooltip': 'Edycja zbiorcza zadań',
  'aet.assignments.title': 'Zadania',
  'aet.assignments.assignmentTitle': 'Zadanie',
  'aet.assignments.dueDate': 'Termin',
  'aet.tabular.searchPlaceholder.assignments': '-',
  'aet.tabular.searchPlaceholder.students': '-',
  'aet.tabular.searchPlaceholder.questions': '-',
  'aet.assignemnts.columnDueDateInfoTooltip': '-',
  'aet.assignemnts.singleDueDateInfoTooltip': '-',
  'aet.assignemnts.masterDueDateInfoTooltip': '-',
  'aet.home.loading': 'Ładowanie...',
  'aet.home.errorFetchingAssignments': 'Błąd pobierania zadań',
  'aet.home.dueThisWeekTitle': 'Termin w tym tygodniu',
  'aet.home.allCaughtUpTitle': 'Wszystko już wiesz!',
  'aet.home.allCaughtUpDescription': 'W tym tygodniu nie masz żadnych zadań do wykonania.',
  'aet.home.suggestedRemediationTitle': '-',
  'aet.home.noSuggestedRemediationTitle': 'Brak sugerowanego materiału do powtórzenia',
  'aet.home.noSuggestedRemediationDescription': 'Sprawdź ponownie po wykonaniu następnego zadania.',
  'aet.home.assignmentIncludesTitle': 'Zadanie obejmuje',
  'aet.home.sectionsLabel': '-',
  'aet.home.questionsCount': '{count} pytania',
  'aet.home.dueLabel': '-',
  'aet.home.due': 'W terminie:',
  'aet.home.progressCompletedLabel': 'Ukończony',
  'aet.home.progressCompletedPastDueLabel': 'Ukończone zaległe',
  'aet.home.progressInProgressLabel': 'W trakcie',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': 'Nierozpoczęte',
  'aet.home.progressCountOfTotal': '-',
  'aet.home.NotAttemptedLabel': 'Nie podjęto próby',
  'aet.home.questionsTotalLabel': 'Łączna liczba pytań',
  'aet.home.progressCompletedOnTimeLabel': 'Ukończone w terminie',
  'aet.home.segmentGreatLabel': 'Świetnie',
  'aet.home.segmentGettingThereLabel': 'OK',
  'aet.home.segmentNeedsReviewLabel': 'Wymaga pracy',
  'aet.home.segmentOkayLabel': 'OK',
  'aet.home.editAssignmentTooltip': 'Edytuj zadanie',
  'aet.home.deleteAssignmentTooltip': 'Usuń zadanie',
  'aet.home.viewDetailsButton': 'Przeglądaj szczegóły',
  'aet.home.viewAsStudentButton': 'Przeglądaj jako student',
  'aet.home.welcomeButtonText': 'Zaczynamy →',
  'aet.review.emptyStateTitle': 'Nie masz niczego do powtórzenia',
  'aet.review.emptyStateDescription': 'Sprawdź ponownie po wykonaniu następnego zadania.',
  'aet.dashboard.tabs.upNext': 'Do góry',
  'aet.dashboard.tabs.welcome': 'Witamy',
  'aet.dashboard.tabs.assignments': 'Zadania',
  'aet.dashboard.tabs.review': 'Powtórzenie',
  'aet.dashboard.tabs.studentRoster': 'Studenci',
  'aet.dashboard.classSchedule': 'Harmonogram zajęć:',
  'aet.syllabus.dueTimeLabel': 'Termin',
  'hero.accessEducatorGuides': 'Uzyskaj dostęp do przewodników dla nauczycieli',
  'aet.assignment.save': 'Zapisz',
  'aet.assignment.finish': 'Koniec',
  'aet.assignment.saveAndAdd': 'Zapisz i dodaj kolejne',
  'aet.assignment.delete': 'Usuń',
  'aet.assignment.saveAndClose': 'Zapisz i zamknij',
  'aet.studentRoster.title': 'Studenci',
  'aet.studentRoster.titlev1': 'Student',
  'aet.studentRoster.dueDatesAdjustmentLabel': '-',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Standardowa',
  'aet.studentRoster.dueDateAdjustment.option.2': '-',
  'aet.studentRoster.dueDateAdjustment.option.3': '-',
  'aet.studentRoster.dueDateAdjustment.option.5': '-',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '-',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '-',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': '-',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} of {total} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': '{skippedCount} assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'No assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'All assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.success.title.multiple': '{count} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.single': 'New due dates have been added to <b>{assignmentTitle}</b>.',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.multiple': 'New due dates have been added to multiple assignments.',
  'aet.bulkEdit.bulkSplitInstruction': 'Podzielimy Twoje zadania równo.',
  'aet.bulkEdit.Description': '-',
  'aet.bulkEdit.firstAssignmentDue': 'Pierwsze zadanie do oddania',
  'aet.bulkEdit.lastAssignmentDue': 'Ostatnie zadanie do oddania',
  'aet.bulkEdit.assignmentsDueDays': 'W jakie dni chcesz oddawać zadania?',
  'aet.bulkEdit.addEditLaterText': 'Wykorzystujemy sztuczną inteligencję do tworzenia zadań.Zadania można zawsze dodać i edytować później.',
  'aet.bulkEdit.monday': 'Poniedziałek',
  'aet.bulkEdit.tuesday': 'Wtorek',
  'aet.bulkEdit.wednesday': 'Środa',
  'aet.bulkEdit.thursday': 'Czwartek',
  'aet.bulkEdit.friday': 'Piątek',
  'aet.bulkEdit.saturday': 'Sobota',
  'aet.bulkEdit.sunday': 'Niedziela',
  'aet.toast.assignmentCreated.title': '1 assignment created',
  'aet.toast.assignmentCreated.title.multiple': '{count} assignments created',
  'aet.toast.assignmentCreated.single': 'Assignment was named <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentCreated.multiple': 'Assignment names were also added.',
  'aet.toast.assignmentUpdated.title': '-',
  'aet.toast.assignmentUpdated.title.single': '1 assignment updated',
  'aet.toast.assignmentUpdated.single': 'Your changes have been saved to <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentUpdated.multiple': '-',
  'aet.toast.assignmentPublished.single': '{count} assignment published',
  'aet.toast.assignmentPublished.multiple': '{count} assignments published',
  'aet.toast.assignmentPublished.subtitle': 'Treść zadania można edytować do momentu, gdy studenci rozpoczną pracę.',
  'aet.toast.assistedScheduleCreated.single': '{count} Assignment created!',
  'aet.toast.assistedScheduleCreated.multiple': '{count} Assignments created!',
  'aet.toast.assistedScheduleCreated.subtitle': 'Default assignment titles were updated based on content.',
  'aet.toast.assistedSchedulePublished.single': '{count} Assignment published!',
  'aet.toast.assistedSchedulePublished.multiple': '{count} Assignments published!',
  'aet.toast.viewAssignment': 'Przeglądaj zadanie',
  'aet.toast.viewAssignments': 'Przeglądaj zadania',
  'aet.welcome.title': 'Twój podręcznik eTextbook Pearson jest teraz połączony z kursem LMS',
  'aet.welcome.LMSAccounTitle': 'Poznaj spostrzeżenia',
  'aet.welcome.LMSAccounDescription': 'Zobacz dokładnie, z jakimi tematami Twoja klasa ma trudności.',
  'aet.welcome.createAssignmentsTitle': 'Utwórz zadania',
  'aet.welcome.createAssignmentsDescription': 'Przypisuj rozdziały ręcznie lub poprzez przesłanie programu nauczania.',
  'aet.welcome.progressViewTitle': 'Śledź wyniki w swoim LMS',
  'aet.welcome.progressViewDescription': 'Wybierz ustawienia synchronizacji ocen w kursie LMS',
  'aet.assignmentDetails.noAssignmentFound': 'Nie znaleziono zadania',
  'aet.assignments.loadingErrorTitle': 'Nie można teraz załadować zadania',
  'aet.assignments.loadingErrorDescription': 'Spróbuj odświeżyć lub sprawdź później.',
  'aet.assignmentStudentDetails.noDataFound': 'Nie ma jeszcze żadnych danych',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Nie ma zarejestrowanych studentów',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Studenci dołączą do Twoich zajęć po zakupie podręcznika eTextbook.',
  'aet.home.editAssignmentTooltipDisabled': 'Nie można edytować: praca ucznia w toku',
  'aet.home.deleteAssignmentTooltipDisabled': 'Nie można usunąć: praca ucznia w toku',
  'aet.home.StudentDetails.questions': 'Pytania',
  'aet.home.StudentDetails.attempts': 'Próby',
  'aet.home.StudentDetails.comprehension': 'Pewność',
  'hero.titleInfo.tooltip': 'Informacja tytułowa',
  'aet.home.publishAssignments': 'Opublikuj wszystkie zadania',
  'aet.assignments.saveScheduleAsDraft': 'Zapisz harmonogram jako wersję roboczą',
  'aet.assignments.reviewBeforePublishAlert': 'Sprawdź swoje zadania, a następnie opublikuj je, aby były widoczne dla studentów.',
  'aet.assignments.copiedCoursePublishAlert': 'Dodaj terminy do skopiowanych zadań i opublikuj je, aby były widoczne dla studentów.',
  'aet.assignments.allSetPublishAlert': 'Wszystko gotowe? Opublikuj swoje zadania, aby były widoczne dla studentów.',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': 'Niektóre treści stworzone przy użyciu sztucznej inteligencji na podstawie materiałów edukacyjnych Pearson. Pearson dysponuje procesem walidacji danych wyjściowych, jednak generatywna sztuczna inteligencja może nadal generować niedokładne informacje o ludziach, miejscach lub faktach.',
  'aet.home.bulkEditTitle': 'Edytuj zadania zbiorczo',
  'aet.home.bulkEditSubtitle': 'Wprowadź zmiany w swoim sylabusie, a następnie ponownie prześlij go tutaj. Twoje zadania i terminy zostaną odpowiednio zaktualizowane.',
  'aet.home.createAssignmentTitle': 'Utwórz zadania',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Uwzględnione w innym zadaniu',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Niektóre sekcje zostały uwzględnione w innym zadaniu',
  'aet.welcome.welcome.Title': 'Witamy!',
  'aet.home.student.roaster.ProgressTitle': 'Całkowite ukończenie',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Sprawdź ponownie, gdy studenci rozpoczną zadanie.',
  'aet.home.whatDueThisWeekTitle': 'Oto, co należy zrobić w tym tygodniu',
  'aet.assignments.edit.errorTitle': '{count} zadania zawierają błędy',
  'aet.assignments.edit.errorSubTitle': 'Zadania zawierające błędy nie mogą zostać opublikowane. Edytuj je lub opublikuj bez nich.',
  'aet.assignments.edit.publishAnyway': 'Opublikuj mimo wszystko',
  'aet.assignments.edit.editAssignments': 'Edytuj zadania',
  'aet.assignments.edit.validationInfoToolTip': 'Edytuj zadanie, aby usunąć błędy',
  'aet.assignments.error.assignmentCreated.title': 'Wszystkie zadania zawierają błędy',
  'aet.assignments.error.assignmentCreated.description': 'Zadania zawierające błędy nie mogą zostać opublikowane. Edytuj je lub wypróbuj inny program nauczania.',
  'aet.assignments.error.uploadSyllabus': 'Prześlij sylabus',
  'aet.assignments.error.editAssignments': 'Edytuj zadania',
  'aet.mondly.title': 'Języki',
  'aet.studentRoster.errorState.title': 'Lista studentów niedostępna',
  'aet.studentRoster.errorState.description': 'Nie udało się załadować listy uczniów. Spróbuj odświeżyć stronę lub sprawdź później.',
  'aet.assignments.sectionLabel': 'sekcja(-e)',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.tags.dueNext': 'Due next',
  'aet.assignments.tags.pastDue': 'Past due',
  'aet.assignments.completionLabel': 'answered',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': 'pytanie(-a)',
  'aet.assignments.assignmentsLabel': 'zadanie(-a)',
  'aet.assignments.performanceProgressBar': 'Pasek postępu wydajności',
  'aet.assignments.completionProgressBar': 'Pasek postępu realizacji',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Czy na pewno chcesz usunąć to zadanie?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Czy na pewno chcesz usunąć te zadania?',
  'aet.home.nextAssignmentTitle': 'Następne zadanie',
  'aet.home.courseSettings': 'Ustawienia kursu',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Zasoby Pearson+ eTextbook',
  'aet.home.etextbookInformation': 'Informacje o eTextbook',
  'aet.multiple.deleteAssignmentKeepCTA': 'Zachowaj zadanie(-a)',
  'aet.syllabus.processingText.header': 'Organizujemy zadania związane z czytaniem przypisane do Twoich zajęć - zajmie to tylko chwilę.',
  'aet.syllabus.processingText.uploading': 'Przesyłanie Twojego dokumentu',
  'aet.syllabus.processingText.activating': 'Aktywacja komponentów sztucznej inteligencji',
  'aet.syllabus.processingText.extracting': 'Wyodrębnianie zadań związanych z czytaniem',
  'aet.syllabus.processingText.mapping': 'Mapowanie treści podręcznika',
  'aet.syllabus.processingText.finishing': 'Kończenie',
  'aet.syllabus.uploadErrorMessage': 'Upewnij się, że plik PDF lub .docx ma rozmiar poniżej 10 MB i że połączenie internetowe jest stabilne',
  'aet.syllabus.uploadNoAssignmentsMessage': 'Nie znaleziono zadań związanych z czytaniem',
  'aet.syllabus.uploadNoAssignmentsDescription': 'Nie udało nam się pobrać zadań związanych z czytaniem z tego pliku. Można je dodać ręcznie.',
  'aet.syllabus.uploadFailedRetryCTA': 'Spróbuj ponownie',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': 'Sprawdź jeszcze raz, czy w sylabusie znajduje się <qualities a syllabus should have for this to work>, a następnie spróbuj ponownie lub przejdź do ręcznego tworzenia zadań.',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': 'Tworzenie ręczne',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': 'Coś poszło nie tak',
  'aet.syllabus.uploadModal.genericFailure.body1': 'Nie udało nam się przesłać i przetworzyć sylabusa.',
  'aet.syllabus.uploadModal.genericFailure.body2': 'Sprawdź połączenie i spróbuj ponownie lub przejdź do ręcznego tworzenia przypisania.',
  'aet.syllabus.uploadModal.successTotal.title': 'Gotowy do sprawdzenia',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': 'Gotowy do sprawdzenia',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': 'Sprawdź zadania',
  'aet.syllabus.selectChapterWithQuestions': 'Wybierz rozdział z pytaniami.',
  'preferenceSetting.subTitle': 'Te ustawienia będą domyślne dla wszystkich studentów tego kursu.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Interakcje z AI',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Włącz narzędzie do nauki AI i podsumowania AI w wynikach wyszukiwania',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Pokaż materiały przygotowujące do nauki związane z tą książką',
  'aet.syllabus.footer': 'Tworzenie zadań odbywa się przy pomocy AI',
  'aet.dashboard.footerDialogDeatils': 'Generatywna sztuczna inteligencja AI służy do tworzenia pytań do zadań domowych w oparciu o materiały edukacyjne Pearson. Pearson dysponuje procesem walidacji danych wyjściowych, jednak generatywna sztuczna inteligencja AI może nadal generować niedokładne informacje o ludziach, miejscach lub faktach. Sztuczna inteligencja służy również do grupowania treści w zadania na podstawie dostarczonego przez Ciebie sylabusa i/lub harmonogramu.',
  'aet.review.footer': 'Utworzono przy użyciu AI',
  'aet.footerCard.dismiss': 'Odrzuć',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Przygotowanie do nauki to dodatkowe narzędzie wspomagające naukę poprzez udostępnianie uczniom materiałów wideo i zadań praktycznych dostosowanych do potrzeb tego kursu.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Studenci, których plan dostępu nie obejmuje Przygotowania do nauki, mogą zostać poproszeni o subskrypcję w celu dalszego korzystania z tej usługi i powiązanych z nią materiałów.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Ustawienie to nie będzie miało wpływu na studentów, którzy już zakupili Przygotowanie do nauki.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Dowiedz się więcej o korzyściach płynących z programu Przygotowanie do nauki',
  'aet.home.viewCourseId': 'Wyświetl ID kursu',
  'aet.home.copy': 'Kopiuj',
  'aet.home.copied': 'Skopiowano',
  'aet.home.courseLabel': 'ID kursu:',
  'schoolInfoCard.addUniversity': '-',
  'schoolInfoCard.title': 'Informacje o szkole',
  'schoolInfoCard.titleV1': 'Opowiedz nam o swoim kursie',
  'schoolInfoCard.cta': 'Zaczynamy',
  'schoolInfoCard.pickInstitution': '-',
  'schoolInfoCard.addUniversityTitle': 'Dodaj swoją szkołę',
  'schoolInfoCard.addUniversitySubtitle': 'Znajomość Twojej szkoły i kierunku studiów pozwoli nam polecić Ci najbardziej przydatne materiały do nauki.',
  'schoolInfoCard.searchPlaceholder': 'Wyszukaj swoją szkołę...',
  'schoolInfoCard.skip': 'Pomiń ten krok',
  'schoolInfoCard.nextStep': 'Następny krok',
  'schoolInfoCard.notInList': 'Moja szkoła nie figuruje na liście',
  'schoolInfoCard.noResults': 'Nie znaleziono szkół odpowiadających Twoim kryteriom wyszukiwania',
  'schoolInfoCard.noResultsHeading': 'Nie możesz znaleźć swojej szkoły?',
  'schoolInfoCard.noResultsInstruction': 'Wpisz poniżej swoje imię i nazwisko',
  'schoolInfoCard.noResultsInputPlaceholder': 'Nazwa szkoły',
  'schoolInfoCard.addInstitutionLabel': 'Dodaj tę szkołę',
  'aet.assignments.assignmentTitlePlaceholder': 'Wpisz tytuł',
  'aet.assignments.titleValidation.titleRequired': 'Wymagany jest tytuł zadania.',
  'aet.assignments.titleValidation.titleTooLong': 'Tytuł zadania nie może być dłuższy niż {0} znaków.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Tytuł zadania zawiera znaki, które nie są obsługiwane.',
  'aet.assignments.titleValidation.titleDuplicate': 'Tytuł zadania już istnieje',
  'aet.syllabus.timeZoneLabel': 'Strefa czasowa',
  'aet.review.reviewReadingFromAssignments': 'Przeglądaj lekturę w ramach zadania',
  'aet.assignments.chaptersLabel': '-',
  'menu.myAccount.subTitle': '-',
  'menu.myAccount.subTitleNotAvailable': '-',
  'schoolInfoCard.toastMessage': '-',
  'aet.review.threeDotMenu.askAI': 'Zadaj pytanie AI',
  'aet.home.suggestedRemediationSubtitle': '-',
  'aet.home.laggedQuestionLabel': 'Oznaczone pytania',
  'aet.home.correctAnswer': 'Poprawna odpowiedź',
  'aet.home.incorrectAnswer': 'Najczęstsze błędne odpowiedzi',
  'aet.home.behaviourTrendsLabel': 'Analiza pytania',
  'aet.home.strugglingStudentsLabel': 'Studenci z trudnościami',
  'aet.home.patternsInStudensAiLabel': 'Wzorce wykorzystania sztucznej inteligencji przez studentów',
  'aet.home.questionLabel': 'Pytanie',
  'aet.home.studentAskingSimilarQuestions': 'Studenci zadające podobne pytania:',
  'aet.home.assignmentDifficultQuestions': 'Trudne pytania',
  'aet.home.behaviorTrends': 'Analiza pytania',
  'aet.home.behaviors': 'Wskaźniki efektywności',
  'aet.home.mostDifficultTopics': '-',
  'aet.home.commentsFromStudentLabel': 'Komentarze od studentów',
  'aet.home.disregard': 'Zignoruj',
  'aet.home.reportAsInaccurate': 'Zgłoś jako nieprawidłowe',
  'aet.home.Flagged': 'Oznaczono',
  'aet.home.reportQuestionTitle': 'Zgłoś pytanie',
  'aet.home.reportQuestionLabel': 'Co było nie tak z tym pytaniem?',
  'aet.home.showComments': 'Pokaż komentarze',
  'aet.home.studentReports': 'raporty studentów',
  'aet.home.placeholderText': 'Proszę o wyjaśnienie...',
  'aet.home.reportQuestion.notRelevant': 'Nie dotyczy',
  'aet.home.reportQuestion.notCorrect': 'Niepoprawne',
  'aet.home.reportQuestion.unsafe': '-',
  'aet.home.reportQuestion.somethingElse': 'Coś innego',
  'aet.home.StudentDetails.assistedByAI': 'Wspomagane przez AI',
  'aet.home.strugglingStudents.emptyStateTitle': 'Żaden ze studentów nie ma obecnie trudności.',
  'aet.home.strugglingStudents.emptyStateDescription': 'Sprawdź później.',
  'aet.home.overallStatus.excelling': 'Doskonałe wyniki',
  'aet.home.overallStatus.fallingBehind': 'Słabe wyniki',
  'aet.home.overallStatus.keepingUp': '-',
  'aet.home.showOnlyDifficultQuestionsLabel': '-',
  'aet.home.showOnlyStrugglingStudentsLabel': '-',
  'aet.home.viewQuestionInAssignment': '-',
  'aet.home.insightRisk.incorrectFirstAttempts': '-',
  'aet.home.insightRisk.multipleIncorrectAttempts': '-',
  'aet.home.insightRisk.lowConfidence': '-',
  'aet.home.insightRisk.mediumConfidence': '-',
  'aet.home.insightRisk.lowEngagement': '-',
  'aet.home.insightRisk.countOfStudents': '-',
  'aet.home.insightRisk.na': 'Nie dotyczy',
  'aet.home.strugglingStudentsHereLabel': '-',
  'aet.home.insightRisk.didNotAttempt': '-',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'Integracja LMS',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.',
  'aet.unlinkCourse.title': 'Unlink Pearson and [LMS] courses?',
  'aet.unlinkCourse.warning.accessInfoBeforePearson': 'Your Pearson course will be unlinked from your [LMS] course. You can still access the Pearson course by signing into ',
  'aet.unlinkCourse.warning.pearsonLinkLabel': 'Pearson',
  'aet.unlinkCourse.warning.accessInfoAfterPearson': ' with your linked account.',
  'aet.unlinkCourse.warning.relinkInfo': 'If no students are enrolled in the Pearson course you’re unlinking, you can link it again with the same [LMS] course.',
  'aet.unlinkCourse.beforeContinueHeading': 'Before you continue:',
  'aet.unlinkCourse.beforeContinueItem': 'If you link your [LMS] course with a different Pearson course, delete all Pearson grades from your [LMS] gradebook and any areas or modules in your LMS course. Otherwise, your [LMS] course may have duplicate grades.',
  'aet.unlinkCourse.inProgressCta': 'Unlinking...',
  'aet.unlinkCourse.okCta': 'OK',
  'aet.unlinkCourse.success.title': 'Unlink successful',
  'aet.unlinkCourse.success.heading': 'Your course has been unlinked from your LMS',
  'aet.unlinkCourse.success.descriptionBeforePearson': 'You can still access the course by signing into ',
  'aet.unlinkCourse.success.descriptionAfterPearson': ' with your Pearson account.',
  'aet.unlinkCourse.failure.title': 'Couldn\'t unlink course',
  'aet.unlinkCourse.failure.paragraph1': 'Your course couldn\'t be unlinked from your LMS. Wait a few minutes and try again.',
  'aet.unlinkCourse.failure.paragraph2': 'If the problem continues, contact Pearson Support.'
};

export default pl;
